<template>
	<template-base>
		<div class="text-center">
			<h1>Renove a sua assinatura!</h1>
			<h4>Data de expiração: {{ expiredDate }} - Valor a pagar: R$ {{ amount }}</h4>
			<h4>Para continuar acessando este recurso, é necessário renová-la.</h4>
		</div>
		<section v-if="qrCodePixBase64 && !errorMsg" class="d-block text-center">
			<img class="image-qrcode" :src="qrCodePixBase64" alt="QR Code Pix"/>
			<div class="container-text-qrcode">
				<h6 id="pixQRCode" class="text-qrcode">{{ qrCodePix }}</h6>
			</div>
			<div class="center mt-1">
				<button class="btn-primary w-15" @click="copyPixQRCode()">
				 Copiar Pix QR Code
			</button>
			</div>
		</section>
		<section v-else>
			<div v-if="isLoading"
				style="position: fixed; height: 50vh; width: 100%; display: flex; align-items: center; justify-content: center;">
				<div class="spinner-border" role="status">
					<span class="sr-only">Carregando...</span>
				</div>
			</div>
			<div v-else>
				<div class="center">
					<AlertTriangleIcon size="150" color="red"/>
				</div>
				<h5 style="color: red; text-align: center;">
					{{ errorMsg }}
				</h5>
				<div class="mt-4 center">
					<button class="btn btn-secondary w-15" @click="loadPay()">
						Tente novamente
					</button>
					<a
						@click="whatsapp"
						target="_blank"
						rel="noopener noreferrer"
						class="ml-4 btn btn-success w-15"
					>
						<PhoneIcon class="mr-2"/>
						Contactar por WhatsApp
					</a>
				</div>
			</div>
		</section>
	</template-base>
</template>

<style scoped>
	section {
		height: 40vh;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.image-qrcode {
		height: 10rem;
	}

	.text-qrcode {
		max-width: 350px;
	}

	.container-text-qrcode {
		display: flex;
		justify-content: center


	}

	.center {
		display: flex;
		text-align: center;
		justify-content: center;
		justify-items: center;
	}

	.w-15 {
		width: 13.5rem;
	}
</style>

<script>
	import TemplateBase from "../templates/Base";
	import { formatterSimple, numberFormatted } from "../helpers/common";
	import { SubscriptionsService } from "@/services/subscriptions";
	import { PaySubscriptionService } from "@/services/paySubscription";

	export default {
		components: { TemplateBase },

		data () {
			return {
				amount: null,
				expiredDate: null,
				subscriptionsService: new SubscriptionsService(),
				paySubscriptionService: new PaySubscriptionService(),
				qrCodePix: null,
				qrCodePixBase64: null,
				idTransaction: null,
				intervalId: null,
				isLoading: false,
				errorMsg: null,
				message: "Olá, preciso de ajuda. Tive um problema na renovação da minha assinatura",
				phoneNumber: "+5566999331539",
				intervalTime: 10000,
				pollingStop: 5,
				pollingCount: 0
			};
		},

		beforeDestroy () {
			clearInterval(this.intervalId);
		},

		mounted () {
			this.loadPay();
		},

		methods: {
			async loadPay () {
				this.qrCodePix = null;
				this.qrCodePixBase64 = null;
				this.idTransaction = null;

				const subscriptionData = localStorage.params ? (JSON.parse(localStorage.params))?.subscription : {};
				this.amount = numberFormatted(subscriptionData.amount);
				this.expiredDate = formatterSimple(new Date(subscriptionData.nextPayDate));
				this.isLoading = true;
				try {
					this.errorMsg = null;
					const paySubscription = await this.paySubscriptionService.checkPaymentIdUser();
					this.qrCodePix = paySubscription.qr_code;
					this.qrCodePixBase64 = `data:image/png;base64,${paySubscription.qr_code_base64}`;
					this.idTransaction = paySubscription.id.toString();

					this.isLoading = false;
					if (paySubscription.status === "approved") {
						this.renew();
					} else if (paySubscription.status === "rejected") {
						await this.$swal.fire({
							title: "Pagamento recusado",
							text: "Não conseguimos concluir sua renovação. O pagamento foi recusado pela institução financeira.  Mas não se preocupe, vamos gerar um novo QR Code pra você!",
							type: "error",
							allowOutsideClick: false
						});
						this.loadPay();
					} else if (paySubscription.status === "cancelled") {
						await this.$swal.fire({
							title: "Ops! Esse QR Code Venceu",
							text: "Parece que o tempo para concluir o pagamento acabou. Mas não se preocupe, vamos gerar um novo QR Code pra você!",
							type: "error",
							allowOutsideClick: false
						});
						this.loadPay();
					} else {
						this.verifyStatus();
					}
				} catch (error) {
					this.isLoading = false;
					this.errorMsg = error.response.data.message || "Erro interno, entre em contato com o administrador do sistema";
				}
			},

			async verifyStatus () {
				try {
					clearInterval(this.intervalId);
					this.pollingCount = ++this.pollingCount;
					this.errorMsg = null;
					const statusPayment = await this.paySubscriptionService.checkPayment({ id: this.idTransaction });
					if (statusPayment.status === "approved") {
						this.renew();
					} else if (statusPayment.status === "pending") {
						if (this.pollingCount === this.pollingStop) {
							const respUser = await this.$swal.fire({
								title: "Esperando pagamento",
								text: "O pagamento ainda não foi confirmado e está levando mais tempo que o esperado. Deseja continuar aguardando?",
								type: "error",
								showCancelButton: true,
								cancelButtonColor: "#A6A8AB",
								confirmButtonColor: "#DD6B55",
								imageWidth: 50,
								imageHeight: 50,
								cancelButtonText: "Não",
								confirmButtonText: "Sim",
								reverseButtons: true,
								allowOutsideClick: false
							});
							if (respUser.value) {
								this.pollingCount = 0;
							} else {
								this.$router.push("/about");
							}
						}

						if (this.pollingCount < this.pollingStop) {
							this.intervalId = setInterval(() => {
								this.verifyStatus();
							}, this.intervalTime);
						}
					} else if (statusPayment.status === "rejected") {
						await this.$swal.fire({
							title: "Pagamento recusado",
							text: "Não conseguimos concluir sua renovação. O pagamento foi recusado pela institução financeira.  Mas não se preocupe, vamos gerar um novo QR Code pra você!",
							type: "error",
							allowOutsideClick: false
						});
						this.loadPay();
					} else if (statusPayment.status === "cancelled") {
						await this.$swal.fire({
							title: "Ops! Esse QR Code Venceu",
							text: "Parece que o tempo para concluir o pagamento acabou. Mas não se preocupe, vamos gerar um novo QR Code pra você!",
							type: "error",
							allowOutsideClick: false
						});
						this.loadPay();
					} else {
						this.loadPay();
					}
				} catch (error) {
					this.isLoading = false;
					this.errorMsg = error.response.data.message || "Erro interno, entre em contato com o administrador do sistema";
				}
			},

			clearDataQrcode () {

			},

			async renew () {
				const userNewToken = await this.subscriptionsService.renewSubscription({});
				if (!userNewToken)
					return;

				this.$store.commit("setUsuarioLogado", null);
				this.$store.commit("setUsuarioLogado", userNewToken);
				await this.$swal.fire({
					title: "Pagamento aprovado",
					text: "Renovação feita com sucesso!",
					type: "success",
					allowOutsideClick: false
				});
				this.$router.push("/");
			},

			copyPixQRCode () {
				const contenido = document.getElementById("pixQRCode").textContent;
				navigator.clipboard.writeText(contenido)
					.then(() => {
						alert("Copiado para a área de transferência!");
					})
					.catch(err => {
						console.error("Error al copiar:", err);
					});
			},

			whatsapp () {
				const baseUrl = "https://api.whatsapp.com/send?phone=";
				const text = encodeURIComponent(this.message);
				window.open(`${baseUrl}${this.phoneNumber}?text=${text}`, "__blank");
			}
		}
	};
</script>